import React, { useState, useEffect } from 'react'
import './navbar.css'
import { AiFillCloseCircle } from "react-icons/ai";
import { TbGridDots } from "react-icons/tb";
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [active, setActive] = useState('navBar')
  const [scrolled, setScrolled] = useState(false)

  // Scroll listener for transparent → blurred background
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const showNav = () => {
    setActive('navBar activeNavbar')
  }

  const removeNavbar = () => {
    setActive('navBar')
  }

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };


  const scrollToHome = () => {
    const contactSection = document.getElementById('home');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className='navBarSection'>
      <header className={`header flex ${scrolled ? 'header--scrolled' : ''}`}>

        <div className="logoDiv">
          <Link to='/' onClick={scrollToHome}>
            <span className="logo">Hookup Room</span>
          </Link>
        </div>

        <div className="navMain flex">
          <div className={active}>
            <ul className="navLists flex">
              <Link to='/' onClick={scrollToHome}>
                <li className="navItem">
                  <span onClick={removeNavbar} className="navLink">Home</span>
                </li>
              </Link>
              <Link to='/services'>
                <li className="navItem">
                  <span onClick={removeNavbar} className="navLink">Services</span>
                </li>
              </Link>
              <Link to='/' onClick={scrollToContact}>
                <li className="navItem">
                  <span onClick={removeNavbar} className="navLink">About</span>
                </li>
              </Link>
              <Link to='/' onClick={scrollToContact}>
                <li className="navItem">
                  <span onClick={removeNavbar} className="navLink">Contact</span>
                </li>
              </Link>
              <li className="navItem">
                <a href="https://t.me/BookHookupRoom" className='btnBook'>BOOK NOW</a>
              </li>
            </ul>

            <div onClick={removeNavbar} className="closeNavbar">
              <AiFillCloseCircle className='icon' />
            </div>

          </div>

          <div onClick={showNav} className="toggleNavbar" aria-label="Toggle Navigation Menu" role="button" tabIndex={0}>
            <TbGridDots className="icon" />
          </div>

        </div>

      </header>
    </section>
  )
}

export default Navbar